import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useAutoUpdate, usePlayerTimes } from '@24i/player-utils-react';
import { areProgramMetadataValid } from '@24i/player-utils';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { PlayerUIContext, formatTimeText } from '@24i/player-ui';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { Time } from '../PlayerUI/RegularView/components/PlayerFooter/styled';
export const Duration = ({ playerInstance, programRange, showHours, showIsLive, className, style, }) => {
    var _a, _b, _c;
    const { durationTime, loadedMetadata } = usePlayerTimes(playerInstance);
    useAutoUpdate();
    const { state: { isVolumeOpened }, } = useContext(PlayerUIContext);
    const { t } = useTranslation(['sott']);
    const { theme } = useTheme();
    const isLive = !!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.live);
    let milliseconds = durationTime;
    let hasValidProgramEnd = false;
    if (isLive && playerInstance && loadedMetadata) {
        const timestamp = playerInstance.getUTCTimestamp(durationTime);
        const { programEnd, programStart } = playerInstance.getMetadata();
        const rangeEnd = (_a = programRange === null || programRange === void 0 ? void 0 : programRange.end) !== null && _a !== void 0 ? _a : programEnd;
        const rangeStart = (_b = programRange === null || programRange === void 0 ? void 0 : programRange.start) !== null && _b !== void 0 ? _b : programStart;
        if (areProgramMetadataValid(rangeStart, rangeEnd)) {
            hasValidProgramEnd = true;
            milliseconds = rangeEnd;
        }
        else {
            milliseconds = timestamp ? timestamp.getTime() : Date.now();
        }
    }
    const timeFormat = (_c = useFeature('localization')) === null || _c === void 0 ? void 0 : _c.timeFormat;
    const timeString = formatTimeText(milliseconds, {
        loadedMetadata,
        showHours,
        timeFormat,
        isLive,
        showLiveLabel: showIsLive && !hasValidProgramEnd,
        liveLabel: t('asset.liveBadge').toUpperCase(),
    });
    return (React.createElement(Time, { "data-test": "Duration-Time", testID: "total_time", className: `Duration ${className}`, style: Object.assign(Object.assign({}, getFont(theme, 'h5')), style), theme: theme, isVolumeOpened }, timeString));
};
Duration.defaultProps = {
    showHours: true,
    showIsLive: true,
    className: '',
    style: null,
};
//# sourceMappingURL=index.js.map